import { useEffect, useState } from "react";
import useFetch from "hooks/useFetch";
import config from "config.json";

interface HotelImage {
  hotel_code: string;
  photos: string[];
}

interface HotelImageDataResponse {
  default_image: string;
  hoteles: HotelImage[];
}

export const useHotelPhotos = (): string[] => {
  const { data: hotelImagesData, error, fetchData } = useFetch<HotelImageDataResponse>(
    'GET',
    `${config.backend_url}/setia/hoteles/ver_todas_fotos`,
    { 'Content-Type': 'application/json' }
  );

  const [photos, setPhotos] = useState<string[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (hotelImagesData) {
      const selected_hotel = sessionStorage.getItem("selected_hotel")
        ? sessionStorage.getItem("selected_hotel")
        : new URLSearchParams(window.location.search).get('hotel');

      const hotel = hotelImagesData.hoteles.find(
        (hotel) => hotel.hotel_code === selected_hotel
      );
      setPhotos(hotel?.photos || []);
    }
    if (error) {
      console.error('Error fetching hotel photos:', error);
    }
  }, [hotelImagesData, error]);

  return photos;
};